const AuthEndpoints = {
  CHECK_AUTH: "/users/me",
  LOGOUT: "/logout",
  GET_USER_INFO: "/users/me",
};

export default AuthEndpoints;
